export default function (legacySize) {
	let size = legacySize?.toLowerCase().trim();
	if (size === "sm" || size === "small") return "s";
	if (size === "md" || size === "medium") return "m";
	if (size === "lg" || size === "large") return "l";
	return "m";
}
